import { render, staticRenderFns } from "./ZakatPenghasilan.vue?vue&type=template&id=58b37be1"
import script from "./ZakatPenghasilan.vue?vue&type=script&lang=js"
export * from "./ZakatPenghasilan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports